import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=448c338d&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c338d",
  null
  
)

export default component.exports